export default __webpack_public_path__ + "static/media/128x128.bf740b49.jpg";